(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    class DDMobileMenu extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }
  connectedCallback() {
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }
  selectTab(selected, focus = false) {
    for (const tab of this.querySelectorAll('[role="tab"]')) {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
      if (panel) panel.hidden = !active;
    }
    this.querySelector('.dd-menu-scroll').scrollTop = 0;
    if (focus) selected.focus();
  }
  onClick(event) {
    const tab = event.target.closest('[role="tab"]');
    if (tab && this.contains(tab)) this.selectTab(tab);
  }
  onKeydown(event) {
    const tab = event.target.closest('[role="tab"]');
    if (!tab || !this.contains(tab)) return;
    const tabs = [...this.querySelectorAll('[role="tab"]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else return;
    event.preventDefault();
    this.selectTab(tabs[index], true);
  }
}
if (!customElements.get('dd-mobile-menu')) customElements.define('dd-mobile-menu', DDMobileMenu);
  } catch(e) { console.error(e); }
})();

})();
